<div #path class="out">

  <div class="path_title" [style.left.px]="path_title_left">
    <span *ngFor="let part of title_parts;let i = index" [ngClass]="{last:i==title_parts.length-1}"  kzLib (click)="select(i)">{{part}}</span>
  </div>

</div>
